import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Report from "@/pages/Report";
import Methodology from "@/pages/Methodology";
import Badge from "@/pages/Badge";
import NotFound from "@/pages/NotFound";
import "@/App.css";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/badge/:id" element={<Badge />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #27272A",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
